__turbopack_context__.v({
  "account-dropdown-button": "UtilityLinks-module-scss-module__r2xRkG__account-dropdown-button",
  "account-links": "UtilityLinks-module-scss-module__r2xRkG__account-links",
  "container": "UtilityLinks-module-scss-module__r2xRkG__container",
  "desktop": "UtilityLinks-module-scss-module__r2xRkG__desktop",
  "find-links": "UtilityLinks-module-scss-module__r2xRkG__find-links",
  "knowledge-center": "UtilityLinks-module-scss-module__r2xRkG__knowledge-center",
  "link": "UtilityLinks-module-scss-module__r2xRkG__link",
  "locale-dropdown": "UtilityLinks-module-scss-module__r2xRkG__locale-dropdown",
  "locale-dropdown-button": "UtilityLinks-module-scss-module__r2xRkG__locale-dropdown-button",
  "locale-image": "UtilityLinks-module-scss-module__r2xRkG__locale-image",
  "mobile": "UtilityLinks-module-scss-module__r2xRkG__mobile",
  "mobile-centered": "UtilityLinks-module-scss-module__r2xRkG__mobile-centered",
  "utility-links": "UtilityLinks-module-scss-module__r2xRkG__utility-links",
});
